import React, { Fragment } from 'react';

const Assigned = ({ users }) => {
  return (
    users && users.length ? users.map((item, index) => (
      `${item.firstName} ${item.lastName}`
    )).join('<br />') : 'N/A'
  );
}

const ClientRequirements = ({ client }) => {

  const item = client.attributes || {};

  return (
    <Fragment>
      <div className="row">
        <label className="title">Preferred technician</label>
        <div className="right">
          <Assigned users={item.technician} />
        </div>
      </div>
      <div className="row">
        <label className="title">Preferred QA</label>
        <div className="right">
          <Assigned users={item.qaEngineer} />
        </div>
      </div>
      <div className="row">
        <label className="title">Preferred survey programmer</label>
        <div className="right">
          <Assigned users={item.surveyManager} />
        </div>
      </div>
      <div className="row">
        <label className="title">Preferred project manager</label>
        <div className="right">
          <Assigned users={item.projectManager} />
        </div>
      </div>
      <div className="row">
        <label className="title">Do not assign</label>
        <div className="right">
          <Assigned users={item.doNotAssign} />
        </div>
      </div>
      <div className="row">
        <label className="title">White gloves</label>
        <div className="right">
          {item.whiteGloves ? 'Yes' : 'No'}
        </div>
      </div>
    </Fragment>
  );
}

export default ClientRequirements;



// WEBPACK FOOTER //
// ./src/components/projects/ProjectSummary/ClientRequirements.js